import CapitalGainAmountError from './CapitalGainAmountError';
class TargetCapitalGainNotReachable extends CapitalGainAmountError {
    constructor(options) {
        super('TARGET_CAPITAL_GAIN_NOT_REACHABLE', options);
    }
}
export default TargetCapitalGainNotReachable;
